<!--
	作者：1764635606@qq.com
	时间：2018-09-04
	描述：通用输入框组件(已全局注册)

	props:
       value:               绑定的值
       type:                input所有支持的类型和textarea
       placeholder：        占位文本
       prefix：             头部图标(支持textarea，但line-height为32px)
       suffix:              尾部图标(支持textarea，但line-height为32px)
       clearable:           是否显示情况按钮
       showEye:             当type='password'的时候生效，若为true则显示眼睛图标，可切换是否展示密码
       disabled:            设置输入框为禁用状态
       maxlength:           最大输入长度
       readonly:            设置输入框为只读
       rows:                textarea的行数
       max:                 type==='number'时最大的数
       min:                 type==='number'时最小的数
       step:                type==='number'时步长
       checkChinese:        是否根据maxlength检测中文长度，一个中文长度占两位
       floatLength：        浮点数小数点后长度，0为整形，负数为不检测，正数为保留小数点后几位(仅当type==='number')(仅当失焦时处理，实时会影响输入体验)
       number:              如果为true返回值将为number型

    methods:

    emit:
        on-input            输入框输入时触发，返回value,返回的数据未处理
        on-change           数据改变时触发,返回event
        on-enter            按下回车键时触发    无
        on-change           数据改变时触发,返回event
        on-focus            输入框聚焦时触发,返回event
        on-blur             输入框失去焦点时触发,返回event
        on-keyup            原生的 keyup 事件,返回event
        on-keydown          原生的 keydown 事件,返回event
        on-keypress         原生的 keypress 事件,返回event
        on-click-prefix     点击输入框头部图标是触发
        on-click-suffix     点击输入框尾部图标是触发

	注意：clearable支持同时与password或suffix之一同时存在
	      checkChinese和floatLength不要同时使用
-->

<template>
    <div class="bp-input-wrapper" :class="wrapperClass">
        <div class="bp-input-prepend" v-if="hasPrepend">
            <slot name="prepend"></slot>
        </div>
        <div class="bp-input-block"
            @mouseenter="showClear"
            @mouseleave="hideClear"
            >
            <span class="bp-input-prefix" v-if="prefix" @click="handlePrefixClick">
                <i class="iconfont bp-icon" :class="prefix"></i>
            </span>
            <textarea
                ref="textarea"
                @input="handleInput"
                @blur="handleBlur"
                @keyup.enter="handleEnter"
                @keyup="handleKeyup"
                @keypress="handleKeypress"
                @keydown="handleKeydown"
                @focus="handleFocus"
                @change="handleChange"
                v-model="currentValue"
                class="bp-input bp-input-textarea"
                v-if="type === 'textarea'"
                :placeholder="placeholder"
                :disabled="disabled"
                :maxlength="maxlength"
                :readonly="readonly"
                :autofocus="autofocus"
                :class="inputClass"
                :rows="rows"></textarea>
            <input class="bp-input"
                ref="input"
                @input="handleInput"
                @blur="handleBlur"
                @keyup.enter="handleEnter"
                @keyup="handleKeyup"
                @keypress="handleKeypress"
                @keydown="handleKeydown"
                @focus="handleFocus"
                @change="handleChange"
                v-model="currentValue"
                :type="input_type"
                :placeholder="placeholder"
                :disabled="disabled"
                :maxlength="maxlength"
                :readonly="readonly"
                :autofocus="autofocus"
                :max="max"
                :min="min"
                :step="step"
                :class="inputClass"
                :autocomplete="autocomplete"
                v-else />
            <span class="bp-input-suffix bp-input-clearable"
                :class="{'bp-input-clearable-two': suffix || canShowEye}"
                v-if="clearable && type !== 'textarea'"
                v-show="isHover"
                @click="handleClear">
                <i class="iconfont bp-icon icon-cha"></i>
            </span>
            <span class="bp-input-suffix bp-input-password"
                :class="{'bp-input-clearable-disabled': disabled}"
                v-if="canShowEye"
                @click="eyeClick">
                <i class="iconfont bp-icon icon-kejian" :class="{'can-see': input_type === 'text'}"></i>
            </span>
            <span class="bp-input-suffix" v-if="suffix" @click="handleSuffixClick">
                <i class="iconfont bp-icon" :class="suffix"></i>
            </span>
        </div>
        <div class="bp-input-append" v-if="hasAppend">
            <slot name="append"></slot>
        </div>
    </div>
</template>

<script>
    import {check} from '@/utils'

    export default{
        props: {
            value: {},
            type: {
                type: String,
                default: 'text'
            },
            placeholder: {
                default: ''
            },
            prefix: {
                type: String
            },
            suffix: {
                type: String
            },
            clearable: {
                type: Boolean,
                default: false
            },
            showEye: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            maxlength: {
                type: Number
            },
            readonly: {
                type: Boolean,
                default: false
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            rows: {
                type: Number,
                default: 3
            },
            max: {
                type: Number
            },
            min: {
                type: Number
            },
            step: {
                type: Number
            },
            checkChinese: {
                type: Boolean,
                default: false
            },
            floatLength: {
                type: Number,
                default: -1
            },
            times: {
                type: Number,
                default: 0
            },
            number: {
                type: Boolean,
                default: false
            },
            isError: {
                type: Boolean,
                default: false
            },
            autocomplete: {
                type: String,
                default: 'new-password'
            }
        },
        computed: {
            hasPrepend () {
                let result = false
                if (this.$slots.prepend) {
                    result = true
                }
                return result
            },
            hasAppend () {
                let result = false
                if (this.$slots.append) {
                    result = true
                }
                return result
            },
            canShowEye () {
                let result = false
                if (this.showEye && this.type === 'password') {
                    result = true
                }
                return result
            },
            inputClass () {
                let arr = []
                if (this.prefix) {
                    arr.push('bp-input-with-prefix')
                }
                if (this.suffix || this.canShowEye) {
                    arr.push(' bp-input-with-suffix')
                }
                if (this.isError) {
                    arr.push('bp-input-error')
                }
                return arr
            },
            wrapperClass () {
                let arr = []
                if (this.hasPrepend || this.hasAppend) {
                    arr.push('bp-input-group')
                }
                if (this.hasPrepend) {
                    arr.push(' bp-input-group-with-prepend')
                }
                if (this.hasAppend) {
                    arr.push(' bp-input-group-with-append')
                }
                return arr
            }
        },
        watch: {
            value (val) {
                if (check.isNull(val)) {
                    this.isFirst = false
                }
                if (this.isFirst && this.type === 'number' && this.times !== 0 && this.floatLength < 0) {
                    this.setTimes(val)
                }
                if (this.currentValue === val) {
                    return
                }
                if (this.checkChinese) {
                    this.filterInput(val)
                }
                else if (this.type === 'number' && this.floatLength > 0 && val !== '' && !this.isFocus) {
                    this.dealFloat(val, this.floatLength)
                }
                else if (this.type === 'number' && this.floatLength === 0 && val !== '') {
                    this.dealFloat(val, this.floatLength)
                }
                else {
                    this.$set(this, 'currentValue', val)
                }
            },
        },
        data () {
            return {
                input_type: this.type === 'number' ? 'text' : this.type,
                isHover: false,
                currentValue: this.value,
                isFocus: false,
                isFirst: true
            }
        },
        mounted () {
        },
        methods: {
            handlePrefixClick (event) { // 头部图标点击事件
                this.$emit('on-click-prefix', event)
            },
            handleSuffixClick (event) { // 尾部图标点击事件
                this.$emit('on-click-suffix', event)
            },
            handleEnter (event) {
                this.$emit('on-enter', event)
            },
            handleKeydown (event) {
                this.$emit('on-keydown', event)
            },
            handleKeypress(event) {
                this.$emit('on-keypress', event)
            },
            handleKeyup (event) {
                this.$emit('on-keyup', event)
            },
            handleFocus (event) {
                this.isFocus = true
                if (this.number || this.type === 'number' && event.target.value !== '') {
                    this.filterInput(event.target.value)
                }
                this.$emit('on-focus', event)
            },
            handleChange (event) {
                this.$emit('on-input-change', event)
            },
            handleBlur (e) {
                this.isFocus = false
                if (this.type === 'number' && this.floatLength > 0 && e.target.value !== '') {
                    this.dealFloat(e.target.value, this.floatLength)
                }
                this.$emit('on-blur', e)
            },
            handleInput (e) {
                let val = e.target.value
                this.$emit('on-input', val)
                if (e.isComposing) { // 输入法输入中
                    return
                }
                if (this.currentValue !== '') {
                    this.showClear()
                }
                if (this.type === 'number' && this.floatLength === 0 && val !== '') {
                    return this.dealFloat(val, this.floatLength)
                }
                this.filterInput(val)
                this.$emit('on-change', e)
            },
            filterInput (val) {
                let result = ''
                if (this.checkChinese) {
                    result = this.checkChineseFunc(val)
                } else {
                    result = val
                }
                if ((this.number || this.type === 'number') && result != '') {
                    result = result.replace(/[^0-9\.\-]/g, '')
                    result = result.charAt(0) + result.substring(1, result.length).replace(/\-/g, '')
                    let num = result.match(/\./g)
                    if (num && num.length > 1) {
                        let index = result.indexOf('.')
                        if (index === 0) {
                            result = result.substring(1, result.length)
                        }
                        else if (index === 1 && !/\d/.test(result.charAt(0))) {
                            result = result.charAt(0) + result.substring(2, result.length)
                            index = result.indexOf('.')
                            result = result.substring(0, index+1) + result.substring(index+1, result.length).replace(/\./g, '')
                        }
                        else {
                            result = result.substring(0, index+1) + result.substring(index+1, result.length).replace(/\./g, '')
                        }
                    }
                }
                this.$set(this, 'currentValue', result)
                this.$emit('input', result)
            },
            checkChineseFunc (val) {
                let len = 0
                let result = ''
                let max = this.maxlength
                for (let i of val) {
                    if (check.isCNChar(i)) {
                        len += 2
                    } else {
                        len += 1
                    }
                    result += i
                    if (len == max) {
                        return result
                    }
                    if (len > max) {
                        return result.slice(0, -1)
                    }
                }
                return result
            },
            dealFloat (value, len) {
                let val = Number(value)
                if (isNaN(val)) {
                    return
                }
                if (this.isFirst && this.times !== 0) {
                    val = this.setTimes(val)
                }
                let result = ''
                if (len === 0) {
                    result = parseInt(val)
                }
                else if (len > 0) {
                    result = val.toFixed(len)
                }
                this.$set(this, 'currentValue', result)
                this.$emit('input', result)
            },
            setTimes (val) {
                let result = 0
                result = this.times < 0 ? val / Math.pow(10, -this.times) : val * Math.pow(10, this.times)
                this.$set(this, 'currentValue', result)
                this.$emit('input', result)
                this.isFirst = false
                return result
            },
            eyeClick () {
                if (this.disabled) {
                    return
                }
                if (this.input_type === 'password') {
                    this.input_type = 'text'
                } else {
                    this.input_type = 'password'
                }
            },
            handleClear () {
                const e = {target: {value: ''}}
                this.$set(this, 'currentValue', '')
                this.$emit('input', '')
                this.$emit('on-change', e)
            },
            showClear () {
                this.isHover = true
                if (this.disabled || !this.currentValue) {
                    this.isHover = false
                }
            },
            hideClear () {
                this.isHover = false
            },
            focus () {
                if (this.type === 'textarea') {
                    this.$refs.textarea.focus()
                } else {
                    this.$refs.input.focus()
                }
            },
            blur () {
                if (this.type === 'textarea') {
                    this.$refs.textarea.blur()
                } else {
                    this.$refs.input.blur()
                }
            }
        }
    }
</script>

<style lang="less">
    @primary-color: #4eaffa;
    @error-color: #ed4014;
    @input-border-color: #dcdcdc;
    @input-font-size: 13px;
    @input-font-color: #666666;
    @input-border-radius: 3px;
    @input-icon-color: #999999;

    .ivu-form-item-error{
        .bp-input{
            outline: none;
            border-color: @error-color;
            &:focus{
                border-color: inherit;
                box-shadow: 0 0 0 2px rgba(237, 64, 20, 0.2);
            }
        }
    }
    .bp-input-wrapper{
        display: inline-block;
        width: 100%;
        position: relative;
        vertical-align: middle;
        line-height: normal;
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }
        input[type="number"]{
            -moz-appearance: textfield;
        }
    }
    .bp-input-block{
        position: relative;
    }
    .bp-input{
        display: inline-block;
        width: 100%;
        height: 32px;
        line-height: 1.5;
        padding: 4px 7px;
        font-size: @input-font-size;
        border: 1px solid @input-border-color;
        color: @input-font-color;
        border-radius: @input-border-radius;
        background: white;
        &::-webkit-input-placeholder {
            color: #CCCCCC;
        }
        &:focus{
            outline: none;
            border-color: @primary-color;
            box-shadow: 0 0 0 2px rgba(78, 175, 250, 0.2);
        }
    }
    .bp-input[disabled]{
        background-color: #F3F3F3;
    }
    .bp-input-textarea{
        max-width: 100%;
        min-height: 32px;
        height: auto;
        vertical-align: bottom;
        margin: 0;
        resize: none;
    }
    .bp-input-with-prefix{
        padding-left: 32px;
    }
    .bp-input-with-suffix{
        padding-right: 32px;
    }
    .bp-input-prefix, .bp-input-suffix{
        width: 32px;
        height: 100%;
        position: absolute;
        top: 0;
        text-align: center;
        i{
            color: @input-icon-color;
            line-height: 32px;
        }
    }
    .bp-input-prefix{
        left: 0;
    }
    .bp-input-suffix{
        right: 0;
    }
    .bp-input-password{
        cursor: pointer;
        .can-see{
            color: #53b0f7;
        }
        i{
            font-size: 22px;
        }
    }
    .bp-input-clearable{
        cursor: pointer;
        i{
            font-size: 15px;
        }
    }
    .bp-input-clearable-two{
        right: 32px;
    }
    .bp-input-clearable-disabled{
        cursor: default;
    }
    .bp-input-error{
        outline: none;
        border-color: @error-color;
        &:focus{
            border-color: inherit;
            box-shadow: 0 0 0 2px rgba(237, 64, 20, 0.2);
        }
    }
    .bp-input-group{
        display: table;
        border-collapse: separate;
        width: 100%;
        font-size: 13px;
        position: relative;
        .bp-input-prepend, .bp-input-append, .bp-input-block{
            display: table-cell;
        }
        .bp-input-prepend, .bp-input-append{
            width: 1px;
            border-radius: 3px;
            border: 1px solid @input-border-color;
            text-align: center;
            background: #F8F8F9;
            vertical-align: middle;
            padding: 0 7px;
            white-space: nowrap;
            .ivu-select{
                min-width: 80px;
                margin: 0px -7px;
                margin-bottom: -3px;
            }
            .ivu-select-selection{
                background: transparent;
                border: none;
            }
            .ivu-select-visible .ivu-select-selection{
                box-shadow: none;
            }
        }
        .bp-input-prepend{
            border-right: 0;
            border-bottom-right-radius: 0;
            border-top-right-radius: 0;
        }
        .bp-input-append{
            border-left: 0;
            border-bottom-left-radius: 0;
            border-top-left-radius: 0;
        }
    }
    .bp-input-group-with-prepend .bp-input-block>.bp-input{
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
    }
    .bp-input-group-with-append .bp-input-block>.bp-input{
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
    }
</style>
